<header class="content-header">
    <nav class="breadcrumb">
        <a *ngIf="item" [routerLink]="['/applications', item.Number, 'person'] | localize" class="bc-back">
            {{'applications_edit_titlePrefix' | translate}}
            "{{item.AdmissionTitle}}", {{item.Number}}
        </a>
    </nav>
    <h1 [translate]="'modif_title'"></h1>
</header>

<ngx-datatable #grid
               class="tight"
               [rows]="gridItems"
               [headerHeight]="'auto'"
               [footerHeight]="50"
               [rowHeight]="'auto'"
               [columnMode]="'flex'"
               [limit]="100"
               [externalSorting]="true"
               [loadingIndicator]="gridLoading"
               [messages]="{ emptyMessage: 'gridEmpty' | translate, totalMessage: 'gridTotal' | translate }"
               (sort)="onGridSort($event)">

    <ngx-datatable-column [width]="20"
                          [resizeable]="false"
                          [sortable]="false"
                          [draggable]="false"
                          [canAutoResize]="false"
                          [flexGrow]="1">
        <ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
            <a href="javascript:void(0)"
               [class.datatable-icon-right]="!expanded"
               [class.datatable-icon-down]="expanded"
               (click)="grid.rowDetail.toggleExpandRow(row)">
            </a>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column [name]="'modif_lblModified' | translate" prop="Modified" [flexGrow]="1">
        <ng-template ngx-datatable-cell-template let-row="row">
            {{row.Modified | appDate:'+'}}
        </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [name]="'modif_lblAction' | translate" prop="ModifAction" [flexGrow]="1">
        <ng-template ngx-datatable-cell-template let-row="row">
            {{'modif_action_' + row.ModifAction | translate}}
        </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [name]="'modif_lblUser' | translate" prop="ModifiedByName" [flexGrow]="1"></ngx-datatable-column>
    <ngx-datatable-column [name]="'applications_lblEduInstitution' | translate" prop="Institution" [flexGrow]="1">
        <ng-template ngx-datatable-cell-template let-row="row">
            {{row.Institution || row.InstitutionText}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-row-detail [rowHeight]="'auto'" #detailRow>
        <ng-template let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
            <mat-checkbox [ngClass]="{'app-hide-unchanged': !showUnchanged.checked }" #showUnchanged>{{ 'modif_show_unchanged' | translate }}</mat-checkbox>
            <div [ngClass]="{ 'app-differ': row.hasChanged('YearTo') }"><label [translate]="'applications_lblEduYearTo'"></label> {{row.YearTo}}</div>
            <div [ngClass]="{ 'app-differ': row.hasChanged('Level') }"><label [translate]="'applications_lblEduLevel'"></label> {{row.Level}}</div>
            <div [ngClass]="{ 'app-differ': row.hasChanged('DiplomaNumber') }"><label [translate]="'applications_lblEduDiplomaNumber'"></label> {{row.DiplomaNumber}}</div>
            <div [ngClass]="{ 'app-differ': row.hasChanged('IsSelected') }"><label [translate]="'applications_lblEduIsSelected'"></label> {{yesno(row.IsSelected)}}</div>
            <div [ngClass]="{ 'app-differ': row.hasChanged('EducationAcquiredIn') }"><label [translate]="'applications_historylblEduAcquiredIn'"></label> {{row.EducationAcquiredIn}}</div>
            <div [ngClass]="{ 'app-differ': row.hasChanged('Location') }"><label [translate]="'applications_lblEduLocation'"></label> {{row.Location}}</div>
            <div [ngClass]="{ 'app-differ': row.hasChanged('UseInContract') }"><label [translate]="'applications_lblEduUseInContract'"></label> {{yesno(row.UseInContract)}}</div>
            <div [ngClass]="{ 'app-differ': row.hasChanged('SendFilesToDvs') }"><label [translate]="'applications_lblEduSendFilesToDvs'"></label> {{yesno(row.SendFilesToDvs)}}</div>
        </ng-template>
    </ngx-datatable-row-detail>

</ngx-datatable>
